import { GridColumnCount } from "./uiTypes";

export class KeyValue<P, T> {
  key: P;
  value: T;
  columnCount?: GridColumnCount;

  constructor(key: P, value: T, columnCount?: GridColumnCount) {
    this.key = key;
    this.value = value;
    this.columnCount = columnCount;
  }
}
